const incomeFields = [
  'GrossIncome',
  // 'NetIncome', //NetIncomeYearly does not exists on BE yet
  'PartnerNetIncome',
  'PartnerGrossIncome',
  'CoApplicantGrossIncome',
  'CoApplicantNetIncome',
];

export const transformIncome = (
  data: Record<string, unknown>,
  from: 'fromApi' | 'toApi'
) => {
  const result = {};

  if (from === 'toApi') {
    for (const field of incomeFields) {
      if (`Frontend/${field}Monthly` in data) {
        Object.assign(result, {
          [`LoanApplication/${field}Yearly`]:
            Number(data[`Frontend/${field}Monthly`]) * 12,
        });
      }
    }
  }

  if (from === 'fromApi') {
    for (const field of incomeFields) {
      if (`LoanApplication/${field}Yearly` in data) {
        Object.assign(result, {
          [`Frontend/${field}Monthly`]:
            Number(data[`LoanApplication/${field}Yearly`]) / 12,
        });
      }
    }
  }

  return result;
};
